var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFulfilmentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13012_29085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2932 8.94968H16.344V1.38452C16.344 1.04654 16.0704 0.772949 15.7324 0.772949C15.6006 0.772949 1.11954 0.772949 0.72876 0.772949C0.390778 0.772949 0.117188 1.04654 0.117188 1.38452V15.1374C0.117188 15.4749 0.390778 15.7488 0.72876 15.7488H10.6647V20.1614C10.6647 20.4994 10.9387 20.7729 11.2762 20.7729H19.2932C19.6307 20.7729 19.9048 20.4994 19.9048 20.1614V9.56125C19.9048 9.22372 19.6307 8.94968 19.2932 8.94968ZM18.6816 19.5498H11.8878V10.1728H18.6816V19.5498ZM1.34033 1.99609H5.57755V7.34171C5.57755 7.83167 6.12167 8.11685 6.5242 7.85349L8.23044 6.73593L9.93698 7.85349C10.3435 8.11975 10.8836 7.82709 10.8836 7.34171V1.99609H15.1208V8.94968H11.2762C10.9387 8.94968 10.6647 9.22372 10.6647 9.56125V14.5258H1.34033V1.99609ZM9.66049 6.21042L8.56552 5.49326C8.36227 5.3602 8.09937 5.35989 7.89566 5.49326L6.80054 6.21042V1.99609H9.66049V6.21042Z",
    fill: "#03071E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2471 11.6899C12.4392 11.6899 12.4378 12.9131 13.2471 12.9131H17.3241C18.1319 12.9131 18.1333 11.6899 17.3241 11.6899C16.8953 11.6899 13.6628 11.6899 13.2471 11.6899Z",
    fill: "#03071E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3251 14.25C16.8963 14.25 13.6637 14.25 13.2481 14.25C12.4359 14.25 12.4404 15.473 13.2481 15.473H17.3251C18.133 15.473 18.1342 14.25 17.3251 14.25Z",
    fill: "#03071E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.324 16.8101H13.247C12.4392 16.8101 12.4377 18.0332 13.247 18.0332H17.324C18.132 18.0332 18.1332 16.8101 17.324 16.8101Z",
    fill: "#03071E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13012_29085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.772949)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFulfilmentActive);
export default __webpack_public_path__ + "static/media/fulfilment-active.50495d475062cc835f53c25386dae60a.svg";
export { ForwardRef as ReactComponent };